var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{staticClass:"content"},[_c('el-container',[_c('el-main',[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }